import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import LabSignup from './LabSignup';
import { supabase } from '../supabaseClient';

export default function DynamicLabSignup() {
  const { labSlug } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [labExists, setLabExists] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkLabExists = async () => {
      if (!labSlug) {
        setLabExists(false);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('labs')
          .select('id, name, short_slug, is_active')
          .eq('short_slug', labSlug)
          .eq('is_active', true)
          .single();

        if (error || !data) {
          setLabExists(false);
          toast({
            title: 'Lab not found',
            description: `No active laboratory found with slug "${labSlug}". Redirecting to general signup.`,
            status: 'warning',
            duration: 5000,
            isClosable: true,
          });
          // Redirect to generic signup after delay
          setTimeout(() => {
            navigate('/lab-signup');
          }, 2000);
        } else {
          setLabExists(true);
        }
      } catch (error) {
        console.error('Error checking lab:', error);
        setLabExists(false);
        toast({
          title: 'Error',
          description: 'Unable to verify laboratory. Redirecting to general signup.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        setTimeout(() => {
          navigate('/lab-signup');
        }, 2000);
      } finally {
        setLoading(false);
      }
    };

    checkLabExists();
  }, [labSlug, navigate, toast]);

  // Show loading state or error state or the lab-specific signup page
  // The LabSignup component handles all states internally
  return <LabSignup />;
}
